<template>
  <div>
    <template v-if="sessionSpeakers.length > 0">
      <h3>Speakers</h3>
      <h5>Connect with speakers</h5>
      <b-row style="margin-top: 25px">
        <b-col v-for="(aSessionSpeaker, i) in sessionSpeakers" cols="4" :key="`speaker-${i}`" >
          <b-card
              text-variant="dark"
              class="text-center"
              style="border-radius: 15px; background-color: #e4e6eb"
          >
            <div class="mb-2">
              <b-avatar
                  :src="aSessionSpeaker.imgURL"
                  size="6rem"
                  style="border-color: red;border-width: 5px"
              />
            </div>
            <b-card-text>
              {{ aSessionSpeaker.name }}
            </b-card-text>
            <b-card-text>
              {{ aSessionSpeaker.position }}
            </b-card-text>
            <b-card-text>
              Company
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </template>
    <div v-else>
      <b-button
        pill
        variant="primary"
        @click="handleAddDataButtonClick"
      >
        Add Speakers
      </b-button>
    </div>
  </div>
</template>

<script>
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  name: "Sessions_Speakers",
  components: {
    TipTapOutput
  },
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  computed: {},
  methods: {
    handleAddDataButtonClick() {
       this.$emit('add-data-click');
    }
  },
  data() {
    return {
      sessionDescription:
        this.session && this.session.session && this.session.session.description
          ? this.session.session.description
          : "",
      sessionSpeakers:
        this.session && this.session.session && this.session.session.crew
        && Array.isArray(this.session.session.crew) ?
            this.session.session.crew
          : []
    };
  }
};
</script>

<style lang="scss" scoped></style>
